import { defineComponent } from 'vue'
import type { ExtractPropTypes, PropType } from 'vue'

export const querytableColumnNumberProps = () => ({
  head: String,
  headAlign: String as PropType<'left' | 'right' | 'center'>,
  bodyAlign: String as PropType<'left' | 'right' | 'center'>,
  name: String,
  width: [String, Number],
  fixed: [Boolean, String],

  thousandsSeparator: {
    type: Boolean,
    default: true,
  },
  precision: {
    type: Number,
    default: -1,
  },
  percentage: {
    type: Boolean,
    default: false,
  },
})

export type QuerytableColumnNumberProps = Partial<ExtractPropTypes<ReturnType<typeof querytableColumnNumberProps>>>

export default defineComponent({
  name: 'OQuerytableColumnNumber',
  inheritAttrs: false,
  props: querytableColumnNumberProps(),
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
